import type { BaseUsecase } from '@usecases/base-usecase';
import type { PrerecordedMessage } from '@entities/prerecorded-message';
import { ScvObjectManager } from '@main/sf-connector/scv-object-manager';
import { Logger } from '@main/utils/logger';

export interface FetchPrerecordedMessagesUsecase
  extends BaseUsecase<void, PrerecordedMessage[]> {
  hideComponent(): unknown;
  run(): Promise<PrerecordedMessage[]>;
}

export interface FetchPrerecordedMessagesEventPublisher {
  publish(): Promise<PrerecordedMessage[]>;
}

export class FetchPrerecordedMessages
  implements FetchPrerecordedMessagesUsecase
{
  private logger = new Logger();

  constructor(private publisher: FetchPrerecordedMessagesEventPublisher) {}

  async run(): Promise<PrerecordedMessage[]> {
    try {
      const messages = await this.publisher.publish();

      ScvObjectManager.notifyScv({
        type: 'SCV.GET_VOICEMAIL_OPTIONS_FULFILLED',
        data: messages,
      });

      this.logger.info('SCV: Sent voicemail options', {
        count: messages.length,
      });

      return messages;
    } catch (error) {
      ScvObjectManager.notifyScv({
        type: 'SCV.GET_VOICEMAIL_OPTIONS_REJECTED',
        data: {
          message: 'Failed to fetch voicemail options',
          error: String(error),
        },
      });

      this.logger.error('SCV: Failed to fetch voicemail options', { error });
      return [];
    }
  }

  async hideComponent() {
    ScvObjectManager.notifyScv({
      type: 'SCV.HIDE_VOICEMAIL_OPTIONS',
      data: {
        message: 'Hide Voicemail Options',
      },
    });
  }
}
